// @flow
import { message } from 'antd'

export function showErrorMessage(error: Object) {
  if (typeof error.message === 'string') {
    error.message
      .split('\\n')
      .map(errorMessage => message.warning(errorMessage))
    return
  }
  message.warning(i18n.t(`error.${error.status || 'default'}.title`))
}

export function getFieldErrorMessages(
  error?: ?Object,
  targetField: string | RegExp,
) {
  return ((error || {}).errors || [])
    .filter(e => {
      if (targetField instanceof RegExp) {
        return targetField.test(e.field)
      }
      return e.field.includes(targetField)
    })
    .map(e => e.message)
}



// WEBPACK FOOTER //
// ./src/helpers/error.js